export default {
  pl: {
    Yes: "Tak",
    No: "Nie",
    Cancel: "Anuluj",
    Clear: "Wyczyść",
    Done: "Gotowe",
    Loading: "Wczytywanie...",
    Select: "Wybierz...",
    Search: "Szukaj",
    Back: "Wstecz",
    OK: "OK",

    "dxCollectionWidget-noDataText": "Brak danych do wyświetlenia",

    "dxDropDownEditor-selectLabel": "Wybierz",

    "validation-required": "Wymagane",
    "validation-required-formatted": "{0} jest wymagane",
    "validation-numeric": "Wartość musi być liczbą",
    "validation-numeric-formatted": "{0} musi być liczbą",
    "validation-range": "Wartość poza zakresem",
    "validation-range-formatted": "{0} jest poza zakresem",
    "validation-stringLength": "Niepoprawna długość",
    "validation-stringLength-formatted": "Długość {0} jest niepoprawna",
    "validation-custom": "Wartość jest niepoprawna",
    "validation-custom-formatted": "{0} jest niepoprawna",
    "validation-async": "Wartość jest niepoprawna",
    "validation-async-formatted": "{0} jest niepoprawna",
    "validation-compare": "Wartości nie pasują do siebie",
    "validation-compare-formatted": "{0} nie pasuje",
    "validation-pattern": "Wartość nie pasuje do wzorca",
    "validation-pattern-formatted": "{0} nie pasuje do wzorca",
    "validation-email": "Email jest niepoprawny",
    "validation-email-formatted": "{0}jest niepoprawny",
    "validation-mask": "Wartość jest niepoprawna",

    "dxLookup-searchPlaceholder": "Minimalna ilośc znaków: {0}",

    "dxList-pullingDownText": "Przeciągnij w dół aby odświeżyć...",
    "dxList-pulledDownText": "Puść aby odświeżyć...",
    "dxList-refreshingText": "Odświeżanie...",
    "dxList-pageLoadingText": "Wczytywanie...",
    "dxList-nextButtonText": "Więcej",
    "dxList-selectAll": "Wybierz wszystkie",
    "dxListEditDecorator-delete": "Usuń",
    "dxListEditDecorator-more": "Więcej",

    "dxScrollView-pullingDownText": "Przeciągnij w dół aby odświeżyć...",
    "dxScrollView-pulledDownText": "Puść aby odświeżyć...",
    "dxScrollView-refreshingText": "Odświeżanie...",
    "dxScrollView-reachBottomText": "Wczytywanie...",

    "dxDateBox-simulatedDataPickerTitleTime": "Wybierz godzinę",
    "dxDateBox-simulatedDataPickerTitleDate": "Wybierz datę",
    "dxDateBox-simulatedDataPickerTitleDateTime": "Wybież datę i godzinę",
    "dxDateBox-validation-datetime": "Wartośc musi być datą lub godziną",

    "dxFileUploader-selectFile": "Wybierz plik",
    "dxFileUploader-dropFile": "lub upuść plik tutaj",
    "dxFileUploader-bytes": "bajtów",
    "dxFileUploader-kb": "kb",
    "dxFileUploader-Mb": "Mb",
    "dxFileUploader-Gb": "Gb",
    "dxFileUploader-upload": "Prześlij",
    "dxFileUploader-uploaded": "Przesłano",
    "dxFileUploader-readyToUpload": "Gotowe do przesłania",
    "dxFileUploader-uploadFailedMessage": "Przesyłanie nie powiodło się",
    "dxFileUploader-invalidFileExtension": "Miedozwolony typ pliku",
    "dxFileUploader-invalidMaxFileSize": "Plik jest za duży",
    "dxFileUploader-invalidMinFileSize": "Plik jest za mały",

    "dxRangeSlider-ariaFrom": "Od",
    "dxRangeSlider-ariaTill": "Do",
    "dxSwitch-switchedOnText": "ON",
    "dxSwitch-switchedOffText": "OFF",

    "dxForm-optionalMark": "opcjonalne",
    "dxForm-requiredMessage": "{0} jest wymagane",

    "dxNumberBox-invalidValueMessage": "Wartość musi być liczbą",
    "dxNumberBox-noDataText": "Brak danych",

    "dxDataGrid-columnChooserTitle": "Wybór kolumn",
    "dxDataGrid-columnChooserEmptyText": "Upuść kolumnę tutaj aby ją ukryć",
    "dxDataGrid-groupContinuesMessage": "Ciąg dalszy na następnej stronie",
    "dxDataGrid-groupContinuedMessage": "Kontynuacja z poprzedniej strony",
    "dxDataGrid-groupHeaderText": "Grupuj po tej kolumnie",
    "dxDataGrid-ungroupHeaderText": "Wyłącz grupowanie",
    "dxDataGrid-ungroupAllText": "Wyłącz grupowanie dla wszystkich",
    "dxDataGrid-editingEditRow": "Edycja",
    "dxDataGrid-editingSaveRowChanges": "Zapisz",
    "dxDataGrid-editingCancelRowChanges": "Anuluj",
    "dxDataGrid-editingDeleteRow": "Usuń",
    "dxDataGrid-editingUndeleteRow": "Przywróć",
    "dxDataGrid-editingConfirmDeleteMessage":
      "Czy na pewno chcesz usunąć ten wiersz?",
    "dxDataGrid-validationCancelChanges": "Wyczyść zmiany",
    "dxDataGrid-groupPanelEmptyText":
      "Upuść nagłówek kolumny tutaj, aby po niej grupować",
    "dxDataGrid-noDataText": "Brak danych",
    "dxDataGrid-searchPanelPlaceholder": "Szukaj...",
    "dxDataGrid-filterRowShowAllText": "(Wszystko)",
    "dxDataGrid-filterRowResetOperationText": "Wyczyść",
    "dxDataGrid-filterRowOperationEquals": "Równa się",
    "dxDataGrid-filterRowOperationNotEquals": "Nie równa się",
    "dxDataGrid-filterRowOperationLess": "Mniejsze niż",
    "dxDataGrid-filterRowOperationLessOrEquals": "Mniejsze lub równe",
    "dxDataGrid-filterRowOperationGreater": "Większe niż",
    "dxDataGrid-filterRowOperationGreaterOrEquals": "Większe lub równe",
    "dxDataGrid-filterRowOperationStartsWith": "Zaczyna się od",
    "dxDataGrid-filterRowOperationContains": "Zawiera",
    "dxDataGrid-filterRowOperationNotContains": "Nie zawiera",
    "dxDataGrid-filterRowOperationEndsWith": "Kończy się na",
    "dxDataGrid-filterRowOperationBetween": "Pomiędzy",
    "dxDataGrid-filterRowOperationBetweenStartText": "Początek",
    "dxDataGrid-filterRowOperationBetweenEndText": "Koniec",
    "dxDataGrid-applyFilterText": "Zastosuj filtr",
    "dxDataGrid-trueText": "prawda",
    "dxDataGrid-falseText": "fałsz",
    "dxDataGrid-sortingAscendingText": "Sortuj rosnąco",
    "dxDataGrid-sortingDescendingText": "Sortuj malejąco",
    "dxDataGrid-sortingClearText": "Usuń sortowanie",
    "dxDataGrid-editingSaveAllChanges": "Zapisz zmiany",
    "dxDataGrid-editingCancelAllChanges": "Porzuć zmiany",
    "dxDataGrid-editingAddRow": "Dodaj wiersz",
    "dxDataGrid-summaryMin": "Min: {0}",
    "dxDataGrid-summaryMinOtherColumn": "Min z {1} to {0}",
    "dxDataGrid-summaryMax": "Max: {0}",
    "dxDataGrid-summaryMaxOtherColumn": "Max z {1} to {0}",
    "dxDataGrid-summaryAvg": "Avg: {0}",
    "dxDataGrid-summaryAvgOtherColumn": "Średnia z {1} to {0}",
    "dxDataGrid-summarySum": "Sum: {0}",
    "dxDataGrid-summarySumOtherColumn": "Suma z {1} to {0}",
    "dxDataGrid-summaryCount": "Ilość: {0}",
    "dxDataGrid-columnFixingFix": "Przypnij",
    "dxDataGrid-columnFixingUnfix": "Odepnij",
    "dxDataGrid-columnFixingLeftPosition": "Do lewej strony",
    "dxDataGrid-columnFixingRightPosition": "Do prawej strony",
    "dxDataGrid-exportTo": "Eksport",
    "dxDataGrid-exportToExcel": "Eksport do pliku Excel",
    "dxDataGrid-exporting": "Eksportowanie...",
    "dxDataGrid-excelFormat": "Plik Excel",
    "dxDataGrid-selectedRows": "Wybrane wiersze",
    "dxDataGrid-exportSelectedRows": "Eksportuj wybrane wiersze",
    "dxDataGrid-exportAll": "Eksportuj wszystko",
    "dxDataGrid-headerFilterEmptyValue": "(Puste)",
    "dxDataGrid-headerFilterOK": "OK",
    "dxDataGrid-headerFilterCancel": "Anuluj",
    "dxDataGrid-ariaColumn": "Kolumna",
    "dxDataGrid-ariaValue": "Wartość",
    "dxDataGrid-ariaFilterCell": "Filtruj komórkę",
    "dxDataGrid-ariaCollapse": "Zwiń",
    "dxDataGrid-ariaExpand": "Rozwiń",
    "dxDataGrid-ariaDataGrid": "Tabela",
    "dxDataGrid-ariaSearchInGrid": "Szukaj w tabeli",
    "dxDataGrid-ariaSelectAll": "Wybierz wszystkie",
    "dxDataGrid-ariaSelectRow": "Wybierz wiersz",
    "dxDataGrid-filterBuilderPopupTitle": "Kreator filtrów",
    "dxDataGrid-filterPanelCreateFilter": "Ustaw filtr",
    "dxDataGrid-filterPanelClearFilter": "Usuń filtr",
    "dxDataGrid-filterPanelFilterEnabledHint": "Aktywuj filtr",

    "dxTreeList-ariaTreeList": "Lista",
    "dxTreeList-editingAddRowToNode": "Dodaj",

    "dxPager-infoText": "Strona {0} z {1} ({2} elemetów)",
    "dxPager-pagesCountText": "z",

    "dxPivotGrid-grandTotal": "Grand Total",
    "dxPivotGrid-total": "{0} Total",
    "dxPivotGrid-fieldChooserTitle": "Field Chooser",
    "dxPivotGrid-showFieldChooser": "Show Field Chooser",
    "dxPivotGrid-expandAll": "Expand All",
    "dxPivotGrid-collapseAll": "Collapse All",
    "dxPivotGrid-sortColumnBySummary": 'Sort "{0}" by This Column',
    "dxPivotGrid-sortRowBySummary": 'Sort "{0}" by This Row',
    "dxPivotGrid-removeAllSorting": "Remove All Sorting",
    "dxPivotGrid-dataNotAvailable": "N/A",
    "dxPivotGrid-rowFields": "Row Fields",
    "dxPivotGrid-columnFields": "Column Fields",
    "dxPivotGrid-dataFields": "Data Fields",
    "dxPivotGrid-filterFields": "Filter Fields",
    "dxPivotGrid-allFields": "All Fields",
    "dxPivotGrid-columnFieldArea": "Drop Column Fields Here",
    "dxPivotGrid-dataFieldArea": "Drop Data Fields Here",
    "dxPivotGrid-rowFieldArea": "Drop Row Fields Here",
    "dxPivotGrid-filterFieldArea": "Drop Filter Fields Here",

    "dxScheduler-editorLabelTitle": "Subject",
    "dxScheduler-editorLabelStartDate": "Start Date",
    "dxScheduler-editorLabelEndDate": "End Date",
    "dxScheduler-editorLabelDescription": "Description",
    "dxScheduler-editorLabelRecurrence": "Repeat",

    "dxScheduler-openAppointment": "Open appointment",

    "dxScheduler-recurrenceNever": "Never",
    "dxScheduler-recurrenceDaily": "Daily",
    "dxScheduler-recurrenceWeekly": "Weekly",
    "dxScheduler-recurrenceMonthly": "Monthly",
    "dxScheduler-recurrenceYearly": "Yearly",

    "dxScheduler-recurrenceRepeatEvery": "Repeat Every",
    "dxScheduler-recurrenceRepeatOn": "Repeat On",
    "dxScheduler-recurrenceEnd": "End repeat",
    "dxScheduler-recurrenceAfter": "After",
    "dxScheduler-recurrenceOn": "On",

    "dxScheduler-recurrenceRepeatDaily": "day(s)",
    "dxScheduler-recurrenceRepeatWeekly": "week(s)",
    "dxScheduler-recurrenceRepeatMonthly": "month(s)",
    "dxScheduler-recurrenceRepeatYearly": "year(s)",

    "dxScheduler-switcherDay": "Day",
    "dxScheduler-switcherWeek": "Week",
    "dxScheduler-switcherWorkWeek": "Work Week",
    "dxScheduler-switcherMonth": "Month",

    "dxScheduler-switcherAgenda": "Agenda",

    "dxScheduler-switcherTimelineDay": "Timeline Day",
    "dxScheduler-switcherTimelineWeek": "Timeline Week",
    "dxScheduler-switcherTimelineWorkWeek": "Timeline Work Week",
    "dxScheduler-switcherTimelineMonth": "Timeline Month",

    "dxScheduler-recurrenceRepeatOnDate": "on date",
    "dxScheduler-recurrenceRepeatCount": "occurrence(s)",
    "dxScheduler-allDay": "All day",

    "dxScheduler-confirmRecurrenceEditMessage":
      "Do you want to edit only this appointment or the whole series?",
    "dxScheduler-confirmRecurrenceDeleteMessage":
      "Do you want to delete only this appointment or the whole series?",

    "dxScheduler-confirmRecurrenceEditSeries": "Edit series",
    "dxScheduler-confirmRecurrenceDeleteSeries": "Delete series",
    "dxScheduler-confirmRecurrenceEditOccurrence": "Edit appointment",
    "dxScheduler-confirmRecurrenceDeleteOccurrence": "Delete appointment",

    "dxScheduler-noTimezoneTitle": "No timezone",
    "dxScheduler-moreAppointments": "{0} more",

    "dxCalendar-todayButtonText": "Dziś",
    "dxCalendar-ariaWidgetName": "Calendar",

    "dxColorView-ariaRed": "Red",
    "dxColorView-ariaGreen": "Green",
    "dxColorView-ariaBlue": "Blue",
    "dxColorView-ariaAlpha": "Transparency",
    "dxColorView-ariaHex": "Color code",

    "dxTagBox-selected": "{0} selected",
    "dxTagBox-allSelected": "All selected ({0})",
    "dxTagBox-moreSelected": "{0} more",

    "vizExport-printingButtonText": "Print",
    "vizExport-titleMenuText": "Exporting/Printing",
    "vizExport-exportButtonText": "{0} file",

    "dxFilterBuilder-and": "I",
    "dxFilterBuilder-or": "Lub",
    "dxFilterBuilder-notAnd": "I nie",
    "dxFilterBuilder-notOr": "Lub nie",
    "dxFilterBuilder-addCondition": "Dodaj warunek",
    "dxFilterBuilder-addGroup": "Dodaj grupę",
    "dxFilterBuilder-enterValueText": "<wpisz wartość>",
    "dxFilterBuilder-filterOperationEquals": "Równa się",
    "dxFilterBuilder-filterOperationNotEquals": "Nie równa się",
    "dxFilterBuilder-filterOperationLess": "Mniejsze niż",
    "dxFilterBuilder-filterOperationLessOrEquals": "Mniejsze lub równe",
    "dxFilterBuilder-filterOperationGreater": "Większe niż",
    "dxFilterBuilder-filterOperationGreaterOrEquals": "Większe lub równe",
    "dxFilterBuilder-filterOperationStartsWith": "Zaczyna się od",
    "dxFilterBuilder-filterOperationContains": "Zawiera",
    "dxFilterBuilder-filterOperationNotContains": "Nie zawiera",
    "dxFilterBuilder-filterOperationEndsWith": "Kończy się na",
    "dxFilterBuilder-filterOperationIsBlank": "Jest puste",
    "dxFilterBuilder-filterOperationIsNotBlank": "Nie jest puste",
    "dxFilterBuilder-filterOperationBetween": "Pomiędzy",
    "dxFilterBuilder-filterOperationAnyOf": "Jeden z",
    "dxFilterBuilder-filterOperationNoneOf": "Żaden z",

    "dxHtmlEditor-dialogColorCaption": "Change Font Color",
    "dxHtmlEditor-dialogBackgroundCaption": "Change Background Color",
    "dxHtmlEditor-dialogLinkCaption": "Add Link",
    "dxHtmlEditor-dialogLinkUrlField": "URL",
    "dxHtmlEditor-dialogLinkTextField": "Text",
    "dxHtmlEditor-dialogLinkTargetField": "Open link in new window",
    "dxHtmlEditor-dialogImageCaption": "Add Image",
    "dxHtmlEditor-dialogImageUrlField": "URL",
    "dxHtmlEditor-dialogImageAltField": "Alternate text",
    "dxHtmlEditor-dialogImageWidthField": "Width (px)",
    "dxHtmlEditor-dialogImageHeightField": "Height (px)",
    "dxHtmlEditor-heading": "Heading",
    "dxHtmlEditor-normalText": "Normal text",

    "dxFileManager-newDirectoryName": "Untitled directory",
    "dxFileManager-rootDirectoryName": "Files",
    "dxFileManager-errorNoAccess":
      "Access denied. The operation cannot be completed.",
    "dxFileManager-errorDirectoryExistsFormat":
      "Directory '{0}' already exists.",
    "dxFileManager-errorFileExistsFormat": "File '{0}' already exists.",
    "dxFileManager-errorFileNotFoundFormat": "File '{0}' not found.",
    "dxFileManager-errorDirectoryNotFoundFormat": "Directory '{0}' not found.",
    "dxFileManager-errorWrongFileExtension": "File extension is not allowed.",
    "dxFileManager-errorMaxFileSizeExceeded":
      "File size exceeds the maximum allowed size.",
    "dxFileManager-errorInvalidSymbols":
      "This name contains invalid characters.",
    "dxFileManager-errorDefault": "Unspecified error.",

    "dxFileManager-commandCreate": "New directory",
    "dxFileManager-commandRename": "Rename",
    "dxFileManager-commandMove": "Move",
    "dxFileManager-commandCopy": "Copy",
    "dxFileManager-commandDelete": "Usuń",
    "dxFileManager-commandDownload": "Download",
    "dxFileManager-commandUpload": "Upload files",
    "dxFileManager-commandRefresh": "Refresh",
    "dxFileManager-commandThumbnails": "Thumbnails View",
    "dxFileManager-commandDetails": "Details View",
    "dxFileManager-commandClear": "Clear selection",

    "dxFileManager-dialogDirectoryChooserTitle": "Select Destination Directory",
    "dxFileManager-dialogDirectoryChooserButtonText": "Select",
    "dxFileManager-dialogRenameItemTitle": "Rename",
    "dxFileManager-dialogRenameItemButtonText": "Zapisz",
    "dxFileManager-dialogCreateDirectoryTitle": "New directory",
    "dxFileManager-dialogCreateDirectoryButtonText": "Create",

    "dxFileManager-editingCreateSingleItemProcessingMessage":
      "Creating a directory inside {0}",
    "dxFileManager-editingCreateSingleItemSuccessMessage":
      "Created a directory inside {0}",
    "dxFileManager-editingCreateSingleItemErrorMessage":
      "Directory wasn't created",
    "dxFileManager-editingCreateCommonErrorMessage": "Directory wasn't created",

    "dxFileManager-editingRenameSingleItemProcessingMessage":
      "Renaming an item inside {0}",
    "dxFileManager-editingRenameSingleItemSuccessMessage":
      "Renamed an item inside {0}",
    "dxFileManager-editingRenameSingleItemErrorMessage": "Item wasn't renamed",
    "dxFileManager-editingRenameCommonErrorMessage": "Item wasn't renamed",

    "dxFileManager-editingDeleteSingleItemProcessingMessage":
      "Deleting an item from {0}",
    "dxFileManager-editingDeleteMultipleItemsProcessingMessage":
      "Deleting {0} items from {1}",
    "dxFileManager-editingDeleteSingleItemSuccessMessage":
      "Deleted an item from {0}",
    "dxFileManager-editingDeleteMultipleItemsSuccessMessage":
      "Deleted {0} items from {1}",
    "dxFileManager-editingDeleteSingleItemErrorMessage": "Item wasn't deleted",
    "dxFileManager-editingDeleteMultipleItemsErrorMessage":
      "{0} items weren't deleted",
    "dxFileManager-editingDeleteCommonErrorMessage":
      "Some items weren't deleted",

    "dxFileManager-editingMoveSingleItemProcessingMessage":
      "Moving an item to {0}",
    "dxFileManager-editingMoveMultipleItemsProcessingMessage":
      "Moving {0} items to {1}",
    "dxFileManager-editingMoveSingleItemSuccessMessage": "Moved an item to {0}",
    "dxFileManager-editingMoveMultipleItemsSuccessMessage":
      "Moved {0} items to {1}",
    "dxFileManager-editingMoveSingleItemErrorMessage": "Item wasn't moved",
    "dxFileManager-editingMoveMultipleItemsErrorMessage":
      "{0} items weren't moved",
    "dxFileManager-editingMoveCommonErrorMessage": "Some items weren't moved",

    "dxFileManager-editingCopySingleItemProcessingMessage":
      "Copying an item to {0}",
    "dxFileManager-editingCopyMultipleItemsProcessingMessage":
      "Copying {0} items to {1}",
    "dxFileManager-editingCopySingleItemSuccessMessage":
      "Copied an item to {0}",
    "dxFileManager-editingCopyMultipleItemsSuccessMessage":
      "Copied {0} items to {1}",
    "dxFileManager-editingCopySingleItemErrorMessage": "Item wasn't copied",
    "dxFileManager-editingCopyMultipleItemsErrorMessage":
      "{0} items weren't copied",
    "dxFileManager-editingCopyCommonErrorMessage": "Some items weren't copied",

    "dxFileManager-editingUploadSingleItemProcessingMessage":
      "Uploading an item to {0}",
    "dxFileManager-editingUploadMultipleItemsProcessingMessage":
      "Uploading {0} items to {1}",
    "dxFileManager-editingUploadSingleItemSuccessMessage":
      "Uploaded an item to {0}",
    "dxFileManager-editingUploadMultipleItemsSuccessMessage":
      "Uploaded {0} items to {1}",
    "dxFileManager-editingUploadSingleItemErrorMessage": "Item wasn't uploaded",
    "dxFileManager-editingUploadMultipleItemsErrorMessage":
      "{0} items weren't uploaded",
    "dxFileManager-editingUploadCanceledMessage": "Canceled",

    "dxFileManager-listDetailsColumnCaptionName": "Name",
    "dxFileManager-listDetailsColumnCaptionDateModified": "Date Modified",
    "dxFileManager-listDetailsColumnCaptionFileSize": "File Size",

    "dxFileManager-listThumbnailsTooltipTextSize": "Size",
    "dxFileManager-listThumbnailsTooltipTextDateModified": "Date Modified",

    "dxFileManager-notificationProgressPanelTitle": "Progress",
    "dxFileManager-notificationProgressPanelEmptyListText": "No operations",
    "dxFileManager-notificationProgressPanelOperationCanceled": "Canceled",

    "dxDiagram-categoryGeneral": "Główne",
    "dxDiagram-categoryFlowchart": "Diagram przepływu",
    "dxDiagram-categoryOrgChart": "Organizational Chart",
    "dxDiagram-categoryContainers": "Kontenery",
    "dxDiagram-categoryCustom": "Niestandardowy",
    "dxDiagram-commandProperties": "Właściwości",
    "dxDiagram-commandExport": "Eksport",
    "dxDiagram-commandExportToSvg": "Eksport do SVG",
    "dxDiagram-commandExportToPng": "Eksport do PNG",
    "dxDiagram-commandExportToJpg": "Eksport do JPEG",
    "dxDiagram-commandUndo": "Cofnij",
    "dxDiagram-commandRedo": "Powtórz",
    "dxDiagram-commandFontName": "Font Name",
    "dxDiagram-commandFontSize": "Font Size",
    "dxDiagram-commandBold": "Bold",
    "dxDiagram-commandItalic": "Italic",
    "dxDiagram-commandUnderline": "Underline",
    "dxDiagram-commandTextColor": "Text Color",
    "dxDiagram-commandLineColor": "Line Color",
    "dxDiagram-commandFillColor": "Fill Color",
    "dxDiagram-commandAlignLeft": "Align Left",
    "dxDiagram-commandAlignCenter": "Align Center",
    "dxDiagram-commandAlignRight": "Align Right",
    "dxDiagram-commandConnectorLineType": "Connector Line Type",
    "dxDiagram-commandConnectorLineStraight": "Straight",
    "dxDiagram-commandConnectorLineOrthogonal": "Orthogonal",
    "dxDiagram-commandConnectorLineStart": "Connector Line Start",
    "dxDiagram-commandConnectorLineEnd": "Connector Line End",
    "dxDiagram-commandConnectorLineNone": "None",
    "dxDiagram-commandConnectorLineArrow": "Arrow",
    "dxDiagram-commandAutoLayout": "Auto Layout",
    "dxDiagram-commandAutoLayoutTree": "Tree",
    "dxDiagram-commandAutoLayoutLayered": "Layered",
    "dxDiagram-commandAutoLayoutHorizontal": "Horizontal",
    "dxDiagram-commandAutoLayoutVertical": "Vertical",
    "dxDiagram-commandFullscreen": "Full Screen",
    "dxDiagram-commandUnits": "Units",
    "dxDiagram-commandPageSize": "Page Size",
    "dxDiagram-commandPageOrientation": "Page Orientation",
    "dxDiagram-commandPageOrientationLandscape": "Landscape",
    "dxDiagram-commandPageOrientationPortrait": "Portrait",
    "dxDiagram-commandPageColor": "Page Color",
    "dxDiagram-commandShowGrid": "Show Grid",
    "dxDiagram-commandSnapToGrid": "Snap to Grid",
    "dxDiagram-commandGridSize": "Grid Size",
    "dxDiagram-commandZoomLevel": "Zoom Level",
    "dxDiagram-commandAutoZoom": "Auto Zoom",
    "dxDiagram-commandSimpleView": "Simple View",
    "dxDiagram-commandCut": "Cut",
    "dxDiagram-commandCopy": "Copy",
    "dxDiagram-commandPaste": "Paste",
    "dxDiagram-commandSelectAll": "Wybierz wszystkie",
    "dxDiagram-commandDelete": "Usuń",
    "dxDiagram-commandBringToFront": "Bring to Front",
    "dxDiagram-commandSendToBack": "Send to Back",
    "dxDiagram-commandLock": "Lock",
    "dxDiagram-commandUnlock": "Unlock",
    "dxDiagram-commandInsertShapeImage": "Insert Image...",
    "dxDiagram-commandEditShapeImage": "Change Image...",
    "dxDiagram-commandDeleteShapeImage": "Delete Image",
    "dxDiagram-unitIn": "in",
    "dxDiagram-unitCm": "cm",
    "dxDiagram-unitPx": "px",
    "dxDiagram-dialogButtonOK": "OK",
    "dxDiagram-dialogButtonCancel": "Anuluj",
    "dxDiagram-dialogInsertShapeImageTitle": "Insert Image",
    "dxDiagram-dialogEditShapeImageTitle": "Change Image",
    "dxDiagram-dialogEditShapeImageSelectButton": "Select image",
    "dxDiagram-dialogEditShapeImageLabelText": "or drop file here"
  }
};
